export {
  TextButton,
  type TextButtonProps,
} from '@tui-cruises/mein-schiff-web-react-component-library/src/components/core/TextButton';
